import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function AlertFilledIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M15.473 4.062c-1.535-2.687-5.41-2.687-6.946 0l-6.83 11.953C.173 18.682 2.099 22 5.17 22h13.66c3.072 0 4.998-3.318 3.474-5.985l-6.83-11.953ZM12.75 8.5a.75.75 0 0 0-1.5 0V14a.75.75 0 1 0 1.5 0V8.5ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
